import styles from "./alert-summary.module.less";

export type TAlertMessage = {
  text: string;
};

export type TAlertSummary = {
  heading?: string;
  messages: Array<TAlertMessage>;
  type?: "error" | "success" | "info" | "message";
};

export type TAlertSummaryProps = TAlertSummary & {
  className?: string;
};

export const AlertSummary = ({ heading, messages, className, type = "error" }: TAlertSummaryProps) => {
  return (
    <div className={[styles.wrapper, className, styles[type]].join(" ")}>
      {heading && <p className={[styles.heading, "body-base bold"].join(" ")}>{heading}</p>}
      <ul className={styles.list}>
        {messages.map((message, index) => (
          <li className={"body-base mb-0 "} key={index}>
            {message.text}
          </li>
        ))}
      </ul>
    </div>
  );
};

export default AlertSummary;
